import { LatLng } from 'leaflet';
import { DrawPolygon } from '../components/DrawControl.models/Draw.polygon';
import { IUndoRedoCommand } from './undoRedoCommand';

export class AddPolygonVertexCommand implements IUndoRedoCommand {
  private readonly polygon: DrawPolygon;
  private readonly latlng: LatLng;

  constructor(polygon: DrawPolygon, latlng: LatLng) {
    this.polygon = polygon;
    this.latlng = latlng;
  }

  executeUndo(): void {
    if (this.polygon._markers.length === 1) {
      this.polygon.disable();
      this.polygon.enable();
      return;
    }

    this.polygon.deleteLastVertex();

    this.polygon._updateGuide();
  }

  executeRedo(): void {
    this.polygon.addVertex(this.latlng);

    this.polygon._updateGuide();
  }
}
